import { render } from "./hgfxTk.vue?vue&type=template&id=4737da30"
import script from "./hgfxTk.vue?vue&type=script&lang=js"
export * from "./hgfxTk.vue?vue&type=script&lang=js"

import exportComponent from "F:\\workspace_2022\\ZhaiJiDi\\QT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__